import { useMemo } from 'react';
import { withStyles } from '@material-ui/core';
import FormSectionHeader from '../../../common/FormSectionHeader';

const styles = (theme) => ({
  label: {
    fontSize: theme.textFontSize
  },
  value: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600
  },
  valueContainer: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.gridTextColor
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '40px',
    margin: '8px 0'
  }
});

const Details = ({ label, value, classes }) => {
  return (
    <div className={classes.valueContainer}>
      <span className={classes.label}>{label}</span>
      <span className={classes.value}>{value}</span>
    </div>
  );
};

const DeliveryReceiptDetailsDefault = ({
  index,
  classes,
  exceptionDetails,
  packageTypeList,
  getExceptionDescription,
  isMultipleExceptionsEnabled
}) => {
  const packageType = useMemo(() => {
    const packageType = packageTypeList.find(
      (packageType) => packageType.value === exceptionDetails.packageType
    );
    return packageType?.label || '';
  }, [packageTypeList, exceptionDetails.packageType]);

  const exceptionTitle = useMemo(
    () => getExceptionDescription(exceptionDetails.code),
    [exceptionDetails.code]
  );
  return (
    <>
      {isMultipleExceptionsEnabled && (
        <FormSectionHeader label={`EXCEPTION ${index + 1}`} uppercase />
      )}
      <div className={classes.detailsContainer}>
        <Details label="Type" value={exceptionTitle} classes={classes} />
        <Details label="Pieces" value={exceptionDetails.pieces} classes={classes} />
        <Details label="Package Type" value={packageType} classes={classes} />
      </div>
      <Details label="Description" value={exceptionDetails.description} classes={classes} />
    </>
  );
};

export default withStyles(styles)(DeliveryReceiptDetailsDefault);
